// react core
import { useContext, useState } from "react";

// date handling
import dayjs from "dayjs";

// material design
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";

// entzy context
import configEntzy from "components/config/ConfigEntzy";
import { EventContext } from "components/event/EventContext";
import { TextTag } from "components/utils/common/CommonTags";

// entzy components
import { Typography } from "@mui/material";

// fonts and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSidebar as iconSideRooms } from "@fortawesome/pro-duotone-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-light-svg-icons";
import { faDoNotEnter as iconDisabled } from "@fortawesome/pro-duotone-svg-icons";

function RoomMessagingSelector(props) {
  // const user = props.user;
  const eventContext = useContext(EventContext);

  const visibleRooms = Object.keys(eventContext.state.messaging.rooms).filter(
    (key) =>
      !key.startsWith("ai") &&
      !(
        (key.includes("runner") && !eventContext.state.event.manager) ||
        (key.includes("rider") && eventContext.state.event.manager)
      )
  );
  // move front desk to the front
  const deskIndex = visibleRooms.indexOf("desk");
  if (deskIndex > -1) {
    visibleRooms.splice(deskIndex, 1);
    visibleRooms.unshift("desk");
  }

  const [showDateRooms, setShowDateRooms] = useState(false);

  const handleShowDateRooms = () => {
    setShowDateRooms(!showDateRooms);
  };
  const handleSelectDateRoom = (dateKey) => {
    let sideRoomName = eventContext.state.messaging.activeRoom.split("|")[0];
    if (dateKey !== null) {
      sideRoomName += "|" + dateKey;
    }
    eventContext.setMessageRoom(sideRoomName);
    setShowDateRooms(false);
  };

  return (
    <Box className="box-default">
      <Box
        className="box-default nooverflow bg-black"
        sx={{
          borderRadius: configEntzy.BORDER_SIZE_XL,
        }}
      >
        <Box
          className="box-default bg-white-t25"
          sx={{ p: configEntzy.APP_SPACING_MD }}
          hidden={!eventContext.state.messaging.activeRoom.includes("desk")}
        >
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={iconDisabled} fixedWidth />
            {/* <span>&nbsp;&nbsp;</span>
            <span>No Side Rooms</span>
            <span>&nbsp;&nbsp;</span> */}
          </Typography>
        </Box>

        <Box
          className="box-default action-pointer"
          sx={{ p: configEntzy.APP_SPACING_MD }}
          onClick={handleShowDateRooms}
          hidden={
            showDateRooms ||
            eventContext.state.messaging.activeRoom.includes("desk")
          }
        >
          {eventContext.state.messaging.activeSideRoom ? (
            <Box className="box-default">
              <Typography variant="subtitle2">
                <span
                  style={{
                    backgroundColor: "orange",
                    color: "black",
                    padding: "2px",
                    borderRadius: "10px",
                  }}
                >
                  <span>&nbsp;&nbsp;</span>
                  {dayjs(eventContext.state.messaging.activeSideRoom).format(
                    "ddd DD MMM YYYY"
                  )}
                  <span>&nbsp;&nbsp;</span>
                </span>
              </Typography>
            </Box>
          ) : (
            <Box className="box-default">
              <Typography variant="body2">
                <span>Date Side Rooms</span>
              </Typography>
              <Typography variant="body1">
                <em>Chat by Launch Date</em>
              </Typography>
            </Box>
          )}
        </Box>

        <Collapse
          in={
            showDateRooms &&
            !eventContext.state.messaging.activeRoom.includes("desk")
          }
          timeout={{
            enter: configEntzy.TRANSITIONS.fast,
            exit: configEntzy.TRANSITIONS.default,
          }}
        >
          <Box
            className="box-default"
            sx={{ pb: configEntzy.APP_SPACING_MD2X }}
          >
            <Box
              className="box-default action-pointer"
              sx={{
                p: configEntzy.APP_SPACING_MD,
                mb: configEntzy.APP_SPACING_MD,
              }}
              onClick={handleShowDateRooms}
            >
              <Typography variant="subtitle2" className="text-right">
                <FontAwesomeIcon icon={iconClose} transform="grow-4" />
              </Typography>
              <Typography variant="subtitle2">Select a side room</Typography>
              <Typography variant="subtitle2">
                Chat with people by launch date
              </Typography>
            </Box>

            {eventContext.state.messaging.activeSideRoom && (
              <Box
                className="box-default action-pointer"
                sx={{
                  p: configEntzy.APP_SPACING_SM,
                  mb: configEntzy.APP_SPACING_MD,
                }}
              >
                <TextTag
                  size="md"
                  rounded={true}
                  bgColor="dusk.light"
                  color="white"
                  text={
                    <span>
                      <span>&nbsp;&nbsp;</span>
                      <span>Exit Side Room</span>
                      <span>&nbsp;&nbsp;</span>
                    </span>
                  }
                  textNoCasing={true}
                  onClick={() => {
                    handleSelectDateRoom(null);
                  }}
                />
              </Box>
            )}

            {eventContext.state.event.calendar.dates.launched.all.keys.map(
              (dateKey, index) => {
                const dateDisplay = dayjs(dateKey).format("ddd DD MMM YYYY");
                return (
                  <Box
                    key={dateKey}
                    className="box-default action-pointer"
                    sx={{
                      p: configEntzy.APP_SPACING_SM,
                    }}
                  >
                    <TextTag
                      size="md"
                      rounded={true}
                      bgColor={
                        eventContext.state.messaging.activeSideRoom === dateKey
                          ? "primary.main"
                          : "white"
                      }
                      color="black"
                      text={
                        <span>
                          <span>&nbsp;&nbsp;</span>
                          {dateDisplay}
                          <span>&nbsp;&nbsp;</span>
                        </span>
                      }
                      onClick={() => {
                        handleSelectDateRoom(dateKey);
                      }}
                    />
                  </Box>
                );
              }
            )}

            {eventContext.state.event.calendar.dates.launched.all.keys
              .length === 0 && (
              <Box
                className="box-default"
                sx={{
                  pb: configEntzy.APP_SPACING_MD,
                }}
              >
                <Typography variant="subtitle1" className="content-disabled">
                  <em>No launch dates</em>
                </Typography>
              </Box>
            )}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
}

export default RoomMessagingSelector;
